import React, {Component} from 'react';
import { Trans } from 'react-i18next';
import LocalStorage from '../service/LocalStorage';
import {properties} from '../resources/properties.js';

class LoginAdminPopup extends Component {

  constructor(props) {
    super(props);
    this.state = {};
    this.showPopup = false;
    this.active = false;
  }

  setRowState(){
    const {setRowStatus} = this.props;
    setRowStatus();
  }

  openLoginPopup = () => {
    if(!this.showPopup){
      this.showPopup = true;
      this.setState({});
    }
  }

  closeLoginPopup = () => {
    if(this.showPopup){
      this.showPopup = false;
      this.setState({});
    }
  }

  checkLogin = () => {
    let nameElement = document.getElementById('nameLogin');
    let passwordElement = document.getElementById('passwordLogin');
    if (passwordElement.validity.valid && nameElement.validity.valid) {
      if(nameElement.value === properties.LOGIN_NAME && passwordElement.value === properties.LOGIN_PASSWORD){
        LocalStorage.put('login-cookie', {fecha: new Date().getTime()+43200000, token: properties.TOKEN});//((1000*60)*60)*12h
        this.showPopup = false;
        this.setRowState();
      }
    }
  }

  exitLogin = () => {
    LocalStorage.delete('login-cookie');
    this.showPopup = false;
    this.setRowState();
  }
//style={{color:this.active?'#ffffff':'#405466'}}
  render() {
    const {active} = this.props;
    this.active = active;
    return (
      <div className='loginComponent'>
        {!this.showPopup && (
          <div onClick={this.openLoginPopup}>
            <Trans i18nKey="main.LoginAdminButton">Acceso administración</Trans>
          </div>
        )}
        {this.showPopup && (
          <div className='loginPopup' style={{height: this.active?'30px':'117px'}}>
            <div className='loginCloseButton' onClick={this.closeLoginPopup}>x</div>
            {!this.active && (<div>
              <label htmlFor="nameLogin"><Trans i18nKey="main.name">Nombre</Trans>:</label>
              <input type="text" id="nameLogin" name="nameLogin" required="required" minLength={2}></input>
              <label htmlFor="passwordLogin"><Trans i18nKey="main.code">Código</Trans>:</label>
              <input type="password" id="passwordLogin" name="passwordLogin" required="required" minLength={8}></input>
            </div>)}
            {!this.active && (<button className='accederLogin' onClick={this.checkLogin}><Trans i18nKey="boxComponent.buttonText">Acceder</Trans></button>)}
            {this.active && (<button className='exitLogin' onClick={this.exitLogin}><Trans i18nKey="main.exit">Salir</Trans></button>)}
          </div>
        )}
      </div>
    );
  }
}

export default LoginAdminPopup;
